module.exports = __webpack_public_path__ + "static/media/magnifying-glass.486d63a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/magnifying-glass.svg
// module id = 518
// module chunks = 0